import React from "react";
const KS10LeftoutReason = (props) => {
  const { leftoutReason, setLeftoutReason } = props;
  return (
    <div className="row">
      <div className="mb-3 section-number-box col-sm-12 col-md-12 col-lg-12">
        <div className="mb-3 number">11.</div>
        <div className="details">
          <div className="form-group form-inline">
            <div className="section-label w-100">
              <label className="">If your request to opt out is more than eight weeks after you started employment, or you are a minor who was incorrectly enrolled, give a reason for your late opt-out request</label>
            </div>
            <div className="form-group form-inline">
              <textarea
                className="form-control w-100"
                value={leftoutReason}
                onChange={(e) => setLeftoutReason(e.target.value)}
                maxLength="400"
                rows="4"
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KS10LeftoutReason;
